export const useNumberFormat = (value: number, style: string = 'currency', currency: string = 'KES') =>
  new Intl.NumberFormat('en-KE', {
    style,
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
}).format(value);